import React, { createContext, useState } from "react";
import {Customer} from "@main/customers/models/Customer";

interface DetailsActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: Customer;
  setElement: (element: any) => void;  
}

export const DetailsActionContext = createContext<DetailsActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: new Customer(),
  setElement: () => {},  
});

interface DetailsActionProviderProps {
  children: React.ReactNode;
}

export const DetailsActionProvider: React.FC<DetailsActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(new Customer());

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,    
  };
  return (
    <DetailsActionContext.Provider value={value}>      
      {children}
    </DetailsActionContext.Provider>
  );
};
